import { useCallback, useEffect, useRef, useState } from "react";
import { addMonths, isValid, isWithinInterval, subMonths } from "date-fns";
export const useInViewMonth = ({ startDate, endDate, focusedField, numberOfMonths }) => {
    const [month, setMonth] = useState(startDate && isValid(startDate) ? startDate : new Date());
    const currentMonthRef = useRef(month);
    currentMonthRef.current = month;
    const setValidMonth = useCallback((newMonth) => {
        if (isValid(newMonth)) {
            setMonth(newMonth);
        }
    }, []);
    const setMonthInView = useCallback((nextMonth, offset) => {
        if (!isValid(nextMonth)) {
            return;
        }
        const month = new Date(currentMonthRef.current.getFullYear(), currentMonthRef.current.getMonth());
        const interval = {
            start: month,
            end: addMonths(month, numberOfMonths - 1)
        };
        const isMonthInView = isWithinInterval(nextMonth, interval);
        if (isMonthInView) {
            return;
        }
        setMonth(offset ? subMonths(nextMonth, offset) : nextMonth);
    }, [numberOfMonths]);
    useEffect(() => {
        if (focusedField === "start" || focusedField === null) {
            startDate && setMonthInView(startDate);
            return;
        }
        endDate && setMonthInView(endDate, numberOfMonths - 1);
    }, [focusedField, startDate, endDate, setMonthInView, numberOfMonths]);
    return [month, setValidMonth, setMonthInView];
};
